import type { Task } from '@core/types/task';

export interface TaskDetailSnapshot {
  key: string;
  task: Task | null;
  loading: boolean;
  error: unknown;
}
export const taskDetailKey = (id: string, scope: string) => `${scope}|${id}`;

/** One mounted page owns one request state. Shared store.currentItem is not a
 * view model: another tab or rail can legitimately read another task into it. */
export class TaskDetailRequest {
  private sequence = 0;
  private snapshot: TaskDetailSnapshot = { key: '', task: null, loading: false, error: null };
  constructor(private fetch: (id: string) => Promise<Task | null>, private publish: (value: TaskDetailSnapshot) => void) {}
  cancel() { this.sequence += 1; }
  clearError() { this.snapshot = { ...this.snapshot, error: null }; this.publish(this.snapshot); }
  async load(id: string, scope: string): Promise<void> {
    const sequence = ++this.sequence;
    const key = taskDetailKey(id, scope);
    const retained = this.snapshot.key === key ? this.snapshot.task : null;
    const update = (value: TaskDetailSnapshot) => { this.snapshot = value; this.publish(value); };
    update({ key, task: retained, loading: true, error: null });
    try {
      const task = await this.fetch(id);
      if (sequence !== this.sequence) return;
      update({ key, task: task?.entity?.id === id ? task : null, loading: false, error: null });
    } catch (error) {
      if (sequence === this.sequence) update({ key, task: retained, loading: false, error });
    }
  }
}
